import * as React from 'react';
import classNames from 'classnames';
import './styles.scss';

export interface ILegendProps {
  items: {
    label: React.ReactNode;
    color?: string;
    wide?: boolean;
    square?: boolean;
  }[];
}

const Legend: React.FunctionComponent<ILegendProps> = (props) => {
  if (props.items.length === 0) {
    return null;
  }

  return (
    <ul className={'legend'}>
      {props.items.map((item, itemIndex) => {
        return (
          <li key={itemIndex}>
            {item.color && (
              <div
                className={classNames('legend__swatch', {
                  ['wide']: item.wide,
                  ['square']: item.square,
                })}
                style={{ background: item.color }}
              />
            )}
            <div className={'legend__label'}>{item.label}</div>
          </li>
        );
      })}
    </ul>
  );
};

Legend.displayName = 'Legend';

export default Legend;
